import React from 'react';

import AppLogo from '@/components/ui/AppLogo';

export default function LandingFooter() {
  return (
    <footer
      className="border-t py-12"
      style={{ backgroundColor: 'var(--secondary)', borderColor: 'var(--border)' }}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <AppLogo size={28} />
            <span className="font-serif text-base" style={{ color: 'var(--foreground)' }}>
              ReviewReply AI
            </span>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-6">
            {[
              { label: 'Privacy', href: '#' },
              { label: 'Terms', href: '#' },
              { label: 'Contact', href: '#' },
              { label: 'Blog', href: '#' },
            ].map((link) => (
              <a
                key={`footer-${link.label}`}
                href={link.href}
                className="text-sm transition-colors duration-150"
                style={{ color: 'var(--muted-foreground)' }}
                onMouseEnter={(e) => ((e.target as HTMLElement).style.color = 'var(--primary)')}
                onMouseLeave={(e) => ((e.target as HTMLElement).style.color = 'var(--muted-foreground)')}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
            © 2026 ReviewReply AI Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}